import { create } from 'zustand';

import { IUseContentListStateStore } from '../../model';

export const useContentListStateStore = create<IUseContentListStateStore>((set, get) => ({
	folderState: {},
	setFolderKeyword: (folderId, keyword) =>
		set((state) => ({
			folderState: {
				...state.folderState,
				[folderId]: { ...state.folderState[folderId], keyword },
			},
		})),
	setFolderOrder: (folderId, order) =>
		set((state) => ({
			folderState: {
				...state.folderState,
				[folderId]: { ...state.folderState[folderId], order },
			},
		})),
	clearFolderState: (folderId) =>
		set((state) => ({
			folderState: { ...state.folderState, [folderId]: { keyword: '', order: 'latest' } },
		})),
	getFolderState: (folderId) => {
		if (get().folderState[folderId]) {
			return get().folderState[folderId];
		}
		set((state) => ({
			folderState: {
				...state.folderState,
				[folderId]: { keyword: '', order: 'latest' },
			},
		}));
		return get().folderState[folderId];
	},
}));
